<template>
    <el-dialog
            title="关联系统权限"
            width="80%"
            :close-on-click-modal="false"
            :visible.sync="view.visible">
        <el-table
                size="small"
                :tree-props="{children: 'menuEntityList', hasChildren: 'hasChildren'}"
                :default-expand-all="true"
                :data="dataList"
                ref="dataTable"
                row-key="id"
                border
                style="width: 100%;"
                @select="selectHandle"
                @selection-change="selectionChangeHandle"
        >
            <el-table-column
                    type="selection"
                    header-align="center"
                    align="center"
                    width="50">
            </el-table-column>
            <el-table-column
                    prop="permissionName"
                    header-align="center"
                    min-width="150"
                    label="名称">
            </el-table-column>
            <el-table-column
                    header-align="center"
                    align="center"
                    label="图标">
                <template>
                </template>
            </el-table-column>
            <el-table-column
                    prop="permissionType"
                    header-align="center"
                    align="center"
                    label="类型">
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.permissionType === 1" size="small">目录</el-tag>
                    <el-tag v-else-if="scope.row.permissionType === 2" size="small" type="success">菜单</el-tag>
                    <el-tag v-else-if="scope.row.permissionType === 3" size="small" type="info">按钮</el-tag>
                </template>
            </el-table-column>
            <el-table-column
                    prop="sortNo"
                    header-align="center"
                    align="center"
                    label="排序号">
            </el-table-column>
            <el-table-column
                    prop="routerUrl"
                    header-align="center"
                    align="center"
                    width="150"
                    :show-overflow-tooltip="true"
                    label="菜单URL">
            </el-table-column>
            <el-table-column
                    prop="expression"
                    header-align="center"
                    align="center"
                    width="150"
                    :show-overflow-tooltip="true"
                    label="权限标识">
            </el-table-column>
            <el-table-column
                    prop="remark"
                    header-align="center"
                    align="left"
                    width="150"
                    label="备注">
            </el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="view.visible = false">取消
      </el-button>
      <el-button size="small" type="primary" @click="dataFormSubmit()">确定
      </el-button>
    </span>
    </el-dialog>
</template>

<script>
    import {fetchBgTreeForMainBody, fetchPermsByRoleId, assignPermsForRole} from '@/controller/sys'
    export default {
        data() {
            return {
                dataList: [],
                dataListSelections: [],
                dataListLoading: false,
                multiSelection: [],
                view: {
                    visible: false,
                    conheight: {
                        height: this.$store.state.common.documentClientDefaultHeight * 0.9 - 410 + 'px',
                        'overflow-y': 'auto'
                    }
                },
                viewData: {},
                dataForm: {
                    id: 0
                }
            }
        },
        methods: {
            selectHandle(selection, row){
                this.$nextTick(() => {
                    if(selection.length && selection.indexOf(row) !== -1){
                        // this.selectParents(row.parentId, true)
                        this.selectChildren(row.menuEntityList, true)
                    }else{
                        // this.selectParents(row.parentId, false)
                        this.selectChildren(row.menuEntityList, false)
                    }
                })
            },
            selectParents(parentId, selected){
                let id = null
                this.dataList.forEach( row => {
                    if(row.id === parentId){
                        this.$refs.dataTable.toggleRowSelection(row, selected)
                        id = row.parentId ? row.parentId : null
                        return
                    }
                })
                if(id){
                    this.selectHandle(id, selected)
                }
            },
            selectChildren(rows, selected){
                rows.forEach(row => {
                    this.$refs.dataTable.toggleRowSelection(row, selected)
                    if(row.menuEntityList){
                        this.selectChildren(row.menuEntityList, selected)
                    }
                })
            },
            // 多选
            selectionChangeHandle(val) {
                this.dataListSelections = val
            },
            init(id) {
                this.dataForm.id = id || 0
                this.view.visible = true
                this.dataListLoading = true

                fetchBgTreeForMainBody(
                    {},sessionStorage.getItem('mainBodyId')
                ).then(data => {
                    this.dataList = data.body
                    this.dataListLoading = false
                    this.$nextTick(() => {
                        if (this.dataForm.id) {
                            fetchPermsByRoleId(
                                {},this.dataForm.id
                            ).then(data => {
                                this.multiSelection = data.body
                                this.initMultiSelection(this.dataList)
                            })

                        }
                    })
                })

            },
            initMultiSelection(rows) {
                rows.forEach((row) => {
                    this.multiSelection.forEach((item) => {
                        if (row.id === item.permissionId) {
                            this.$refs.dataTable.toggleRowSelection(row, true)
                        }
                    })
                    if (row.menuEntityList.length > 0) {
                        this.initMultiSelection(row.menuEntityList)
                    }
                })
            },
            // 表单提交
            dataFormSubmit() {
                let ids = this.dataListSelections.map(item => {
                    return item.id
                })
                assignPermsForRole(
                    {
                        'id': this.dataForm.id || undefined,
                        'ids': ids
                    }
                ).then(data => {
                    if (data && data.code === '00') {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 1500,
                            onClose: () => {
                                this.view.visible = false
                                this.$emit('refreshDataList')
                            }
                        })
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            }
        }
    }
</script>
